/**
 * Admin Trade Service
 * Handles all trade-related admin API calls
 */

import { getApi, postApi, updateApi, deleteApi } from '../adminApi';

/**
 * Get all trades list with filters
 * @param {Object} params - Query parameters (page, limit, status, userId, etc.)
 * @returns {Promise}
 */
export const getTradesList = async (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  return getApi(`trades/list?${queryParams}`);
};

/**
 * Get trade details by ID
 * @param {string} tradeId - Trade ID
 * @returns {Promise}
 */
export const getTradeDetails = async (tradeId) => {
  return getApi(`trades/${tradeId}/details`);
};

/**
 * Create bulk trades manually
 * @param {Object} data - Bulk trade data
 * @returns {Promise}
 */
export const createBulkTrades = async (data) => {
  return postApi('trades/bulk', data);
};

/**
 * Create manual bulk trades
 * @param {Object} payload - Bulk trade payload
 * @returns {Promise}
 */
export const createManualBulkTrades = async (payload) => {
  return postApi('trades/manual/bulk', payload);
};

/**
 * Close bulk trade order
 * @param {string} bulkOrderId - Bulk order ID
 * @param {number} closeValue - Close value
 * @param {string} closeDate - Close date (optional)
 * @param {string} closeTime - Close time (optional)
 * @returns {Promise}
 */
export const closeBulkTradeOrder = async (bulkOrderId, closeValue, closeDate, closeTime) => {
  const payload = {
    bulkOrderId,
    closeValue: parseFloat(closeValue)
  };
  
  if (closeDate) {
    payload.closeManualDate = closeDate;
  }
  
  if (closeTime) {
    payload.closeManualTime = closeTime;
  }
  
  return postApi('trades/manual/bulk/close', payload);
};

/**
 * Get manual trades with filters
 * @param {Object} params - Query parameters
 * @returns {Promise}
 */
export const getManualTrades = async (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  return getApi(`trades/manual?${queryParams}`);
};

/**
 * Get bulk trade by ID
 * @param {string} bulkOrderId - Bulk order ID
 * @returns {Promise}
 */
export const getBulkTradeById = async (bulkOrderId) => {
  return getApi(`trades/manual/bulk/${bulkOrderId}`);
};

/**
 * Update manual trade
 * @param {string} bulkOrderId - Bulk order ID
 * @param {Object} data - Update data
 * @returns {Promise}
 */
export const updateManualTrade = async (bulkOrderId, data) => {
  return updateApi(`trades/manual/${bulkOrderId}`, data);
};

/**
 * Delete bulk trade
 * @param {string} bulkOrderId - Bulk order ID
 * @returns {Promise}
 */
export const deleteBulkTrade = async (bulkOrderId) => {
  return deleteApi(`trades/${bulkOrderId}`);
};

/**
 * Delete single trade
 * @param {string} tradeId - Trade ID
 * @returns {Promise}
 */
export const deleteTrade = async (tradeId) => {
  return deleteApi(`trades/${tradeId}`);
};

